module.exports = __webpack_public_path__ + "static/img/荣誉资质.f578a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/荣誉资质.png
// module id = reJ2
// module chunks = 45